import { render, staticRenderFns } from "./Touch.vue?vue&type=template&id=8f8954f6&scoped=true&"
import script from "./Touch.vue?vue&type=script&lang=ts&"
export * from "./Touch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8954f6",
  null
  
)

export default component.exports